function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rating");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "layer1",
  d: "M6 2.1v22a41.8 41.8 0 0 0 26 37.8 41.8 41.8 0 0 0 26-37.8v-22zm32.1 28.7l3.8 11.6-9.9-7.2-9.9 7.2 3.8-11.6-9.9-7.1h12.2L32 12.1l3.8 11.6H48z"
});

var SvgRating = function SvgRating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    "aria-labelledby": "title",
    "aria-describedby": "desc",
    role: "img",
    fill: "currentColor",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating.04cea240.svg";
export { ForwardRef as ReactComponent };